import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILocation, LocationsResponse, LocationsState } from "./index.types";

const initialState: LocationsState = {
  activeLocation: {},
  activeProvider: {},
  multipleActiveProviders: [],
  lastRoles: [],
  isLocationsLoading: false,
  count: 0,
  next: null,
  previous: null,
  locations: [],
};

const name = "locations";

export const locationsSlice = createSlice({
  name,
  initialState,
  reducers: {
    setActiveLocation: (state, action: PayloadAction<ILocation>) => {
      state.activeLocation = action.payload;
    },
    setActiveProvider: (state, action: PayloadAction<any>) => {
      state.activeProvider = action.payload;
    },
    setMultipleActiveProviders: (state, action: PayloadAction<any>) => {
      state.multipleActiveProviders = action.payload;
    },
    setLastRoles: (state, action: PayloadAction<any>) => {
      state.lastRoles = action.payload;
    },
    getLocations: (state) => {
      state.isLocationsLoading = true;
    },
    appendLocations: (state) => {
      state.isLocationsLoading = true;
    },
    getLocationsSuccess: (state, action: PayloadAction<LocationsResponse>) => {
      state.isLocationsLoading = false;
      state.count = action.payload.count;
      state.next = action.payload.next;
      state.previous = action.payload.previous;
      state.locations = action.payload.results.map((s) => ({
        label: s.location_name,
        value: s.id,
      }));
    },
    appendLocationsSuccess: (state, action: PayloadAction<LocationsResponse>) => {
      state.isLocationsLoading = false;
      if (!action.payload) return;
      state.count = action.payload.count;
      state.next = action.payload.next;
      state.previous = action.payload.previous;
      const newLocations = action.payload.results?.map((s) => ({
        label: s.location_name,
        value: s.id,
      }));

      const existingIds = new Set(state.locations?.map((loc) => loc.value));
      const uniqueNewLocations = newLocations?.filter((loc) => !existingIds.has(loc.value));

      state.locations = [...state.locations, ...(uniqueNewLocations?.length ? uniqueNewLocations : [])];
    },
    appendLocationsFail: (state) => {
      state.isLocationsLoading = false;
    },
    getLocationsFail: (state) => {
      state.isLocationsLoading = false;
      state.count = 0;
      state.next = null;
      state.previous = null;
      state.locations = [];
    },
    resetActiveProvider: (state) => {
      state.activeProvider = {};
    },
    resetMultipleActiveProviders: (state) => {
      state.multipleActiveProviders = [];
    },
  },
});

export const {
  getLocations,
  setLastRoles,
  setActiveProvider,
  setActiveLocation,
  resetActiveProvider,
  setMultipleActiveProviders,
  resetMultipleActiveProviders,
  appendLocationsSuccess,
} = locationsSlice.actions;

export default locationsSlice.reducer;

export const getLocationsList = () => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/locations/?page_size=50`,
  },
  type: "getLocations",
});

export const getLocationsFromUrl = (url: string) => ({
  payload: {
    apiName: name,
    method: "get",
    url: url,
  },
  type: "appendLocations",
});
